<template>
  <div id="practice">
    <div class="mb-3 text-sm-right" v-if="false">
      <span class="btn btn-primary ml-3"
        v-for="n in [5, 4, 2, 1, 3]" :key="n"
        v-bind:class="{ 'active': type === n }"
        @click="type = n"
        v-show="typeList.indexOf(n) > -1"> {{ typeName(n) }}
      </span>
    </div>

    <div class="font-size-control questions">
      <div class="card"
        v-for="(row, qindex) in questions" :key="qindex"
        v-if="current === qindex">
        <div class="card-header text-sm-right">
          {{ typeName(row.practiceType) }} {{ (qindex + 1) }} / {{ questions.length }}
        </div>

        <div class="card-block fixed-height text-left p-3">
          <span class="number">{{ ('0' + (qindex + 1)).slice(-2) }}. </span>
          <span class="btn" v-if="row.audio" @click="playAudioFile(row.audio)">
            <i class="fa fa-volume-up" aria-label="audio"></i>
          </span>

          <!-- PracticeType == 4 OR PracticeType == 1 -->
          <div v-if="row.practiceType === 4 || row.practiceType === 1">
            <p v-if="row.practiceType === 1">{{ row.title_i18N[0].value }}</p>
            <span v-for="(option, optionIndex) in row.titleFields" :key="optionIndex">
              <input type="text"
                @focus="resetCheck()"
                v-if="row.answers.indexOf(option.value) > -1"
                v-bind:class="{
                  'wrong': checkAnswer && row.useranswer[option.index] !== row.answers[option.index]
                }"
                v-model="row.useranswer[option.index]"
                :disabled="retryTimes === 0">
                <span v-html="option.value" v-else></span>
            </span>
          </div>

          <!-- PracticeType == 2 -->
          <div v-if="row.practiceType === 2 || row.practiceType === 5">
            <p v-html="row.title"></p>
            <p v-for="(item, index) in row.items" :key="index"
              v-bind:class="{
                'wrong': checkAnswer && row.useranswer[0] === fromCharCode(index) && row.useranswer[0].toLowerCase() !== row.answers[0].toLowerCase()
            }"><input type="radio"
              @focus="resetCheck()"
              :value="fromCharCode(index)"
              v-model="row.useranswer[0]"
              :disabled="retryTimes === 0"> <button class="btn btn-text" @click="selectRadio(qindex, index)" :disabled="retryTimes === 0" v-html="item"></button>
            </p>
          </div>

          <!-- PracticeType == 3 -->
          <div v-if="row.practiceType === 3">
            <p>{{ row.title_i18N[0].value }}</p>
            <span class="questBox"
              :style="{ 'padding-top': (lang === 'Ja') ? '1.3em' : '0.3em' }"
              v-for="(option, optionIndex) in row.questions" :key="optionIndex"
              v-show="row.useranswer_tmp.indexOf(option) === -1"
              @click="resetCheck() && row.useranswer_tmp.push(option) && (row.useranswer[0] = row.useranswer_tmp.join(' '))"
              v-html="option">
            </span>

            <div class="answerPool"
              @blur="(checkAnswer === true) ? checkAnswer = false: checkAnswer = checkAnswer"
              v-bind:class="{
                'wrong': checkAnswer && !isCorrect
              }">
              <span v-for="(option, optionIndex) in row.useranswer_tmp" :key="optionIndex"
                @click="resetCheck() && row.useranswer_tmp.splice(row.useranswer_tmp.indexOf(option), 1)"
                v-html="option">
              </span>
            </div>
          </div>

          <div class="answer" v-if="checkAnswer && retryTimes === 0 || isCorrect">Answer：
            <span v-for="(answer, ans_index) in row.answers"
              :key="ans_index"
              v-html="ans_index > 0 ? ', '+ answer : answer">
            </span>
          </div>

          <div class="mt-3"
            v-bind:class="{ 'right': isCorrect, 'wrong': !isCorrect }"
            v-if="checkAnswer && retryTimes < 2">
            {{ isCorrect ? '答案正確' : '答案錯誤' }}
          </div>
        </div>
      </div>

      <div class="card" v-if="current === -1">
        <div class="card-block fixed-height p-4">
          您的課後測驗結果為：

          <span v-bind:class="{
            'right': score >= passRate,
            'wrong': score < passRate,
          }">{{ (score >= passRate) ? '通過' : '未通過' }}</span>

          <!-- (本測驗只記錄最高成績) -->

          <div class="text-center mt-5 mb-5">
            答對率
            <span v-bind:class="{
              'right': score >= passRate,
              'wrong': score < passRate,
            }" style="font-size: 5em;">{{ score }}%</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 text-right">
      <span class="float-left mr-3">
        <slot name="left"></slot>
      </span>

      <span class="btn btn-danger float-left"
        @click="current = 0"
        v-if="current === - 1">重新開始</span>

      <span class="btn btn-warning"
        @click="checkAnswers()"
        v-if="current >= 0 && current <= (questions.length - 1) && !isAllowToNext">送出答案</span>

      <span class="btn btn-primary"
        @click="current += 1"
        v-if="current >= 0 && current < (questions.length - 1) && isAllowToNext">下一題</span>

      <span class="btn btn-warning"
        @click="current = -1"
        v-if="current >= (questions.length - 1) && isAllowToNext">完成考試</span>

      <span class="btn btn-danger"
        @click="goToWriting()"
        v-if="isWriting && current >= (questions.length - 1) && isAllowToNext">前往寫作課程</span>
    </div>
  </div>
</template>

<script>
  import langMixin from '../../langMixin'
  import audioPlayerMixin from './mixins/audioPlayerMixin.js'
  // import api from '@/api'

  export default {

    name: 'Practice',

    mixins: [audioPlayerMixin, langMixin],

    props: {
      quests: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      }
    },

    data () {
      return {
        questions: [],
        checkAnswer: false,
        type: 4,
        typeList: [],
        current: 0,
        retryTimes: 2,
        rightCount: 0,
        passRate: 70,
        isCorrect: false
      }
    },

    computed: {
      score () {
        return Math.round(this.rightCount / this.questions.length * 100)
      },

      isAllowToNext () {
        return (this.isCorrect || this.retryTimes === 0)
      },

      isWriting () {
        return window.location.hostname === 'livelearning.liveabc.com' && this.$parent.lesson.isWriting
      },

      lang () {
        return this.$parent.lesson.language
      }
    },

    mounted () {
      this.init()
      this.$watch('current', (val, oldVal) => {
        this.stopAudioFile()
        this.rightCount += this.isCorrect ? 1 : 0
        this.retryTimes = 2
        this.isCorrect = false
        this.checkAnswer = false

        if (val === -1) {
          if (this.$parent.lesson.toRecord) {
            // 回傳紀錄伺服器
            // api.Lesson.Record.Practice(this.$parent.lesson.id, this.score)
          }

          this.$emit('score', this.score)
        }

        if (oldVal === -1) {
          this.initUserAnswers()
          this.rightCount = 0
        }
      })
    },

    methods: {
      mappingType (type) {
        if (typeof type !== 'number') {
          let numType = {
            'ListenClozet': 4,
            'ListenComprehension': 2,
            'TranslateClozet': 1,
            'SentencesOrder': 3,
            'MultiChoice': 5
          }

          return numType[type]
        } else {
          return type
        }
      },

      init () {
        let quest = JSON.parse((JSON.stringify(this.quests)))
        let questionsTmp = this.shuffle(quest)
        let questions = []
        let sort = [5, 4, 2, 1, 3]

        for (let i = questionsTmp.length - 1; i >= 0; i--) {
          questionsTmp[i].practiceType = this.mappingType(questionsTmp[i].practiceType)
        }

        while (sort.length > 0) {
          let type = sort.shift()
          for (let i = questionsTmp.length - 1; i >= 0; i--) {
            if (questionsTmp[i].practiceType === type) {
              if (type === 4 || type === 1) {
                let fields = questionsTmp[i].title.split(/<(.+?)>/)
                questionsTmp[i].titleFields = []
                let fieldCount = 0
                for (let idx in fields) {
                  let field = {
                    'isField': (questionsTmp[i].answers.indexOf(fields[idx]) > -1 ? '1' : '0'),
                    'value': fields[idx],
                    'index': (questionsTmp[i].answers.indexOf(fields[idx]) > -1 ? fieldCount++ : -1)
                  }
                  questionsTmp[i].titleFields.push(field)
                }
              }

              questions.push(questionsTmp[i])
            }
          }
        }

        for (let index in questions) {
          this.typeList.push(questions[index].practiceType)
        }

        this.$set(this, 'questions', this.jsonDataParsingRuby(questions))
        this.initUserAnswers()
        this.$watch('type', () => {
          this.initUserAnswers()
        })
      },

      initUserAnswers () {
        this.resetCheck()

        for (let index in this.questions) {
          let answers = []
          let count = this.questions[index].answers.length
          while (count--) {
            answers.push('')
          }

          if (this.questions[index].practiceType === 3) {
            this.$set(this.questions[index], 'questions', this.shuffle(this.questions[index].items.slice(0)))
          }
          this.$set(this.questions[index], 'useranswer', answers)
          this.$set(this.questions[index], 'useranswer_tmp', [])
        }
      },

      resetCheck () {
        (this.checkAnswer === true) ? this.checkAnswer = false : this.checkAnswer = this.checkAnswer

        if (this.retryTimes === 0) {
          this.checkAnswer = true
        }

        return (this.retryTimes > 0)
      },

      checkAnswers () {
        this.checkAnswer = true
        this.retryTimes -= 1
        this.stopAudioFile()

        let quiz = this.questions[this.current]
        let isRight = true
        let i = 0
        switch (quiz.practiceType) {
          case 4:
          case 1:
            for (i = 0; i < quiz.answers.length; i++) {
              if (quiz.answers[i] !== quiz.useranswer[i]) {
                isRight = false
              }
            }
            break
          case 5:
          case 2:
            for (i = 0; i < quiz.answers.length; i++) {
              if (quiz.answers[i].toLowerCase() !== quiz.useranswer[i].toLowerCase()) {
                isRight = false
              }
            }
            break
          case 3:
            for (i = 0; i < quiz.items.length; i++) {
              if (quiz.items[i] !== quiz.useranswer_tmp[i]) {
                isRight = false
              }
            }
            break
        }

        this.isCorrect = isRight
      },

      fromCharCode (index) {
        return String.fromCharCode(65 + index)
      },

      filterByType (typeId) {
        if (this.questions) {
          return this.questions.filter((q) => {
            return q.practiceType === typeId
          })
        }
        return {}
      },

      shuffle (array) {
        let currentIndex = array.length
        let temporaryValue
        let randomIndex

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex)
          currentIndex -= 1

          // And swap it with the current element.
          temporaryValue = array[currentIndex]
          array[currentIndex] = array[randomIndex]
          array[randomIndex] = temporaryValue
        }

        return array
      },

      typeName (type) {
        switch (type) {
          case 5:
            return '選擇題'
          case 4:
            return '聽力填空'
          case 2:
            return '聽力理解'
          case 1:
            return '翻譯填空'
          case 3:
            return '句子重組'
        }

        return ''
      },

      goToWriting () {
        let path = '/student_services/writing.asp?LevelId=' + this.$parent.lesson.level + '&courseType=' + this.$parent.lesson.courseType
        window.top.document !== window.document ? window.top.location = path : window.location = path
      },

      selectRadio (qindex, index) {
        this.resetCheck()
        this.$set(this.questions[qindex], 'useranswer', [this.fromCharCode(index)])
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/style/app.scss";

  #practice {
    .questions {
      // height: 50vh;
      // overflow-y: scroll;

      input {
        color: #000 !important;
        text-align: center;
        border: 0 !important;
        border-bottom: #ccc 1px solid !important;
        background-color: transparent;
        margin-right: 10px;
        margin-left: 10px;

        &:hover, &:focus {
          outline: none;
        }
      }

      .right {
        color: $right-color;
      }

      .wrong {
        color: $wrong-color;
      }

      .number {
        color: #1e77bb;
      }

      .answerPool {
        padding: 1em;
        margin-top: 1em;
        min-height: 5em;
        line-height: 2.5em;
        border: #ccc 1px dashed;
        background-color: #fff;

        span {
          cursor: pointer;
          border: 1px dashed #ccc;
          padding: 3px;
          margin-right: 3px;
        }
      }

      .answer {
        margin-top: 1em;
        color: $right-color;
      }

      .questBox {
        cursor: pointer;
        border: 1px dashed #ccc;
        padding: 0.3em;
        line-height: 2.5em;
        margin-right: 0.5em;
      }

      .btn-text {
        background-color: transparent;
        padding: 0.3em;
      }
    }

    .card .fixed-height {
      height: 400px;
      overflow-y: scroll;
    }

    .btn-warning {
      color: #fff !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Practice.vue?03049756